import { render, staticRenderFns } from "./PricingForSpecialGroupsCard.vue?vue&type=template&id=2ae8af1a&scoped=true"
import script from "./PricingForSpecialGroupsCard.vue?vue&type=script&lang=js"
export * from "./PricingForSpecialGroupsCard.vue?vue&type=script&lang=js"
import style0 from "./PricingForSpecialGroupsCard.vue?vue&type=style&index=0&id=2ae8af1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae8af1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae8af1a')) {
      api.createRecord('2ae8af1a', component.options)
    } else {
      api.reload('2ae8af1a', component.options)
    }
    module.hot.accept("./PricingForSpecialGroupsCard.vue?vue&type=template&id=2ae8af1a&scoped=true", function () {
      api.rerender('2ae8af1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/PricingForSpecialGroups/PricingForSpecialGroupsCard.vue"
export default component.exports